'use strict';

var _extends = require('../../../../@babel/runtime/helpers/esm/extends.js');
var defaultTheme = require('./defaultTheme.js');
var styled$2 = require('../../../styles/esm/styled/styled.js');

var styled = function styled(Component) {
  var componentCreator = styled$2(Component);
  return function (style, options) {
    return componentCreator(style, _extends({
      defaultTheme: defaultTheme
    }, options));
  };
};

var styled$1 = styled;

module.exports = styled$1;
